import { render, staticRenderFns } from "./CashGift.vue?vue&type=template&id=37252f90&"
import script from "./CashGift.vue?vue&type=script&lang=js&"
export * from "./CashGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports